<template>

    <!-- htmlファイル側の「<router-view>」内に表示する内容 -->
    <div>
      <h2 class="vy-kojin-title">{{ title }}</h2>
    </div>

    <article style="padding: 0 10px;">

      <!--メインコンテンツ-->
      <!-- パンくずリスト -->
      <nav style="--bs-breadcrumb-divider:'>';" aria-label="breadcrumb" v-if="type!=2">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" v-on:click="Return_home">Home</a></li>
          <li class="breadcrumb-item" ><a href="#" v-on:click="Return_list">体験プログラム一覧</a></li>
          <li class="breadcrumb-item" >設定</li>
        </ol>
      </nav>

      <div id="manual_area">
          <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />設定画面のマニュアル</span>
          <span v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>
      </div>

      <table class="vy-form-table">

        <tr>
          <td colspan=2>
            <hr style="margin: 0px;">
          </td>
        </tr>

        <!-- QRコード読取 -->
        <tr>
          <th>

            <label for="moshikomi_date">QRコード読取
              <span class="balloon_parent">
                <img class="q_icon" src="../../images/mark/qmark.png"  />
                <span class="balloon" style="width:750px">
                  QRコード読取り機能の使用を、【可】か又は【不可】で選択します。<br>
                  ※【可】の場合、体験ユーザーでQRコード表示、受入先でQRコード読取り機能を使用しチェックインします。<br>
                  &nbsp;&nbsp;【不可】の場合、QRコードの読取り機能を使用しない。
                </span>
              </span>
            </label>

          </th>
          <td>

            <div class="form-check form-check-inline">
              <input type="radio" class="form-check-input" id="checkin_flg1" name="checkin_flg1" value=true v-model="qr_read_flg"  v-on:change="checkEdit"/>
              <label class="form-check-label" for="checkin_flg1">可</label>
            </div>

            <div class="form-check form-check-inline">
              <input type="radio" class="form-check-input" id="checkin_flg2" name="checkin_flg2" value=false v-model="qr_read_flg"  v-on:change="checkEdit"/>
              <label class="form-check-label" for="checkin_flg2">不可</label>
            </div>

          </td>
        </tr>

        <tr>
          <td colspan=2>
            <div class="vy-dotted"></div>
          </td>
        </tr>

        <!-- メール受取り機能 -->
        <tr>
          <th>

            <label for="moshikomi_date">メール受取り機能
              <span class="balloon_parent">
                <img class="q_icon" src="../../images/mark/qmark.png"  />
                <span class="balloon" style="width:750px">
                  メール受取り機能の使用を、【ON】か又は【OFF】で選択します。<br>
                  ※【ON】の場合、体験ユーザーの申込みやキャンセル時のメールや連絡事項などのメッセージの受取り機能を使用します。<br>
                  &nbsp;&nbsp;【OFF】の場合、体験ユーザーの申込みやキャンセル時のメールや連絡事項などのメッセージの受取り機能を使用しない。
                </span>
              </span>
            </label>

          </th>
          <td>

            <div class="form-check form-check-inline">
              <input type="radio" class="form-check-input" id="mail_flg1" name="mail_flg1" value=true v-model="mail_flg"  v-on:change="checkEdit"/>
              <label class="form-check-label" for="mail_flg1">ON</label>
            </div>

            <div class="form-check form-check-inline">
              <input type="radio" class="form-check-input" id="mail_flg2" name="mail_flg2" value=false v-model="mail_flg"  v-on:change="checkEdit"/>
              <label class="form-check-label" for="mail_flg2">OFF</label>
            </div>

          </td>
        </tr>

        <tr>
          <td colspan=2>
            <hr style="margin: 0px;">
          </td>
        </tr>
      </table>

      <div class="sp_only">
        <span v-if="checkEdit_flg==true" v-on:click="Facility_update()" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow" style="background-color: red;">保存する</span>
        <span v-else class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow" style="background-color: lightgrey;">保存する</span>
      </div>
      <!-- スマホ専用ボタン（フローティングメニューの上に配置） -->
      <div class="vy-responsive-menu-container floating_over" 
        style="
        margin-bottom: 50px;
        padding: 10px 0;
        background: rgba(0, 0, 0, .5);
        border: 0px;
        justify-content: space-evenly;">
        <button class="btn btn-primary mx-aut" style="width: 45%; height: 50px;padding: 0;background-color: white;color:#4175d0;border:1px solid #000;text-align:center"  v-on:click="Return_home()">戻る</button>
        
      </div>

    </article>
</template>

<script setup>
/* eslint-disable */ 
import { useRouter,useRoute } from 'vue-router'
import { GlobalData } from '../js/userdata_shisetsu.js'
import { ref } from 'vue';

const router = useRouter()
const route = useRoute()

const cityname = route.params.shakyo
const facility = route.params.shisetsu

const emit = defineEmits(['call'])
const prop = defineProps(['param'])

let facilty_info = ref(prop.param.facility_info)

let qr_read_flg = ref(facilty_info.value.qr_read_flg)
let mail_flg = ref(facilty_info.value.mail_flg)

let title = "設定"

let checkEdit_flg =  ref(false)  // スマホ用の保存ボタン可・不可フラグ

// 1項目でも編集されたらフラグを立てる       親側でやるようにする
let checkEdit = function(){
    checkEdit_flg.value = true   // スマホ用の保存ボタン可・不可フラグをtrueにする
    emit('call',{cmd:'detail_edit'})
}

// 受入先マスタの更新
let Facility_update = function(){
  
    // 親コンポーネントへ更新or新規登録内容を送る
    emit('call',{cmd:'facility_setting_update',
                facility_code:route.params.shisetsu,
                qr_read_flg:qr_read_flg.value,
                mail_flg:mail_flg.value
              });

}

// スマホ用の保存ボタン可・不可フラグをfalseにする
let CeckEdit_off = function(){
    checkEdit_flg.value = false   // スマホ用の保存ボタン可・不可フラグをfalseにする
}

/* コンポーネントの表示に関わる処理 */
let Return_home = function(){
    router.push("/"+cityname+"/"+facility+"/Shisetsu")
}

// パンくずリストのクリックで詳細コンポーネントから検索コンポーネントに戻す
let Return_list = function(){
    router.push("/"+cityname+"/"+facility+"/Shisetsu")
}

// マニュアルを開く
let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/161c0be34f8f80fc87baf85432ed7220"
    window.open(url,"_blank")
}

// Q&Aを開く
let qanda_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/Q-A-175c0be34f8f801998fac72f169fb66b"
    window.open(url,"_blank")
}     

// 申込み・申込み取消の未読チェック
let param = {
    choson_code:cityname,
    facility_code:facility,
    program_kbn:1,
    kubun:'1,2'
}
emit('call',{cmd:'check_moushikomi_message',param:param});

//親コンポーネント側からの呼び出しで利用する関数の指定
defineExpose({
  Facility_update, CeckEdit_off
})

</script>
